import Config from '@/config';
import http, { HttpPromise } from './http';

export default {
  // заявка - стать ген подрядчиком
  genContractorRegister: async (data):Promise<HttpPromise> => {
    const response = await http.post(`${Config.apiHost}/contractor/genContractor/register/`, data);
    return response.data.result;
  },
  // создать новый лот на ген подряд
  createGenContractorLot: async (data):Promise<HttpPromise> => {
    const response = await http.post(`${Config.apiHost}/customer/gencontracts/lot/`, data);
    return response.data.result;
  },
  customer: {
    // получить данные по лоту на ген подряд
    genContractorLotDetail: async (params):Promise<HttpPromise> => {
      const response = await http.get(`${Config.apiHost}/customer/gencontracts/detail/`, { params });
      return response.data.result;
    },
    // список лотов
    list: async (params): Promise<HttpPromise> => {
      const response = await http.get(`${Config.apiHost}/customer/gencontracts/list/`, { params });
      return response.data.result;
    },
    // лот перевести в активный
    toActive: async (data):Promise<HttpPromise> => {
      const response = await http.post(`${Config.apiHost}/customer/gencontracts/toActive/`, data);
      return response.data.result;
    },
    // лот перевести в черновик
    toDraft: async (data):Promise<HttpPromise> => {
      const response = await http.post(`${Config.apiHost}/customer/gencontracts/toDraft/`, data);
      return response.data.result;
    },
    // лот перевести в отмененный
    toCancel: async (data):Promise<HttpPromise> => {
      const response = await http.post(`${Config.apiHost}/customer/gencontracts/cancel/`, data);
      return response.data.result;
    },
    // скачать результаты офферов
    downloadResult: async (params): Promise<HttpPromise> => {
      const response = await http.get(`${Config.apiHost}/customer/gencontracts/downloadResult/`, { params, responseType: 'blob' });
      return response;
    },
    // установить рейтинг для каждого ген подрядчика
    setOffersRating: async (data):Promise<HttpPromise> => {
      const response = await http.post(`${Config.apiHost}/customer/gencontracts/setOffersRating/`, data);
      return response.data.result;
    },
    // выбрать победителя
    setWinner: async (data):Promise<HttpPromise> => {
      const response = await http.post(`${Config.apiHost}/customer/gencontracts/setWinner/`, data);
      return response.data.result;
    },
    // никто не победил победителя
    noWinners: async (data):Promise<HttpPromise> => {
      const response = await http.post(`${Config.apiHost}/customer/gencontracts/noWinners/`, data);
      return response.data.result;
    },
  },
  gencontractor: {
    // получить данные по лоту на ген подряд
    genContractorLotDetail: async (params):Promise<HttpPromise> => {
      const response = await http.get(`${Config.apiHost}/gencontractor/gencontracts/detail/`, { params });
      return response.data.result;
    },
    // список лотов
    list: async (params): Promise<HttpPromise> => {
      const response = await http.get(`${Config.apiHost}/gencontractor/gencontracts/list/`, { params });
      return response.data.result;
    },
    // отправить оффер
    submitOffer: async (data):Promise<HttpPromise> => {
      const response = await http.post(`${Config.apiHost}/gencontractor/gencontracts/submitOffer/`, data);
      return response.data.result;
    },
  },
};
